import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_73: FaireProductEntity = {
  token: "catalog_prod_prod-73",
  type: "product",
  name: "Ceramic Bud Vase - Organic Shape - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 32.33,
  msrpDollars: 80.82,
  sku: "JA0073",
  caseSize: 6,
  material: "Cotton",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 258,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_bath-body"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
